import AnimatedDots from '../components/animated-dots/AnimatedDots'
import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'

export const Logout = () => {
  const { logout } = useAuth0()

  useEffect(() => {
    logout({ logoutParams: { returnTo: window.location.origin } })
  }, [])

  return (
    <div className="flex size-full items-center justify-center">
      Logout <AnimatedDots />
    </div>
  )
}
